import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "@/hooks/use-toast";
import { emailService } from "../services/get-emails";

export default function useEmails({
  page,
  search,
  filter,
}: {
  page: number;
  search?: string;
  filter?: string;
}) {
  const normalizedSearch = search?.trim() || undefined;
  const normalizedFilter = filter || undefined;

  return useQuery({
    queryKey: ["emails", { page, normalizedSearch, normalizedFilter }],
    queryFn: () =>
      emailService.getEmails({
        page,
        search: normalizedSearch,
        filter: normalizedFilter,
      }),
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
  });
}

export function useRetryEmail() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (emailId: string) => emailService.retryEmail(emailId),
    onSuccess: () => {
      toast({
        title: "Retry queued",
        description: "The email retry has been added to the queue.",
      });
      queryClient.invalidateQueries({ queryKey: ["emails"] });
    },
    onError: (error: any) => {
      toast({
        title: "Retry failed",
        description:
          error?.response?.data?.message || "Failed to retry this email.",
        variant: "destructive",
      });
    },
  });
}
